/* Component-specific styles only */
:host {
  display: block;
}
.home-link {
  display: inline-block;
  padding: var(--padding) var(--padding-l);
  background: var(--color-bg-accent);
  color: var(--color-text-inverse);
  text-decoration: none;
  border-radius: var(--border-radius);
  font-weight: var(--font-weight-medium);
}
